module.exports = __webpack_public_path__ + "static/media/reseller.054aecf7.png";